import React, { useState, useEffect } from "react";
import x from '../../../../utils/Icons/X.svg';

export const CarouselImages = ({ data, setData }) => {
  const [images, setImages] = useState(data.images || []);
  const [selectedImage, setSelectedImage] = useState(images[0] || "");

  useEffect(() => {
    // Update the parent component's data whenever images change
    setData(prevData => ({ ...prevData, carouselImages: { images } }));
  }, [images, setData]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map(file => URL.createObjectURL(file));
    setImages(prev => [...prev, ...newImages]);
  };

  const handleRemoveImage = (image) => {
    setImages(prev => {
      const updatedImages = prev.filter(img => img !== image);
      // Revoke the object URL to free up memory
      URL.revokeObjectURL(image);
      // Set the first image as selected if the current one is removed
      if (selectedImage === image) {
        setSelectedImage(updatedImages[0] || "");
      }
      return updatedImages;
    });
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#FFBBBB] w-4 h-4 rounded" />
        <h1>Carousel Images</h1>
      </div>

      <div className="border-[1px] border-dashed text-center p-4 rounded-lg my-4 border-gray-600">
        <p>
          Drop your WebP, PNG or JPEG files here! Up to 8 images, max 3 MB each.
        </p>
        <p className="opacity-60">
          1280x960px, and 72 DPI (dots per inch) for high-res.
        </p>
        <div className="relative flex justify-center items-center space-x-8 my-4">
          <button className="bg-white cursor-pointer text-black px-4 py-2 rounded ">
            Upload Images From Computer
          </button>
          <input
            className="w-full cursor-pointer opacity-0 absolute top-0"
            type="file"
            multiple
            onChange={handleImageChange}
            aria-label="Upload Images"
          />
        </div>
      </div>

      <div className="carousel flex items-center space-x-3 overflow-x-scroll hidescroll w-full">
        {images.map((image, index) => (
          <div key={index} className="relative border p-1 my-2 rounded-lg">
            <img
              className={`w-40 h-[120px] rounded-lg object-cover ${selectedImage === image ? 'border border-[#1c1c1c] dark:border-white p-2' : ''}`}
              src={image}
              alt={`carousel-image-${index}`}
              onClick={() => setSelectedImage(image)}
              aria-label={`Select image ${index + 1}`}
            />
            {selectedImage === image && (
              <div
                className="bg-[#E85959] absolute p-1.5 -top-2 -right-3 w-5 h-5 rounded-full flex items-center justify-center cursor-pointer"
                aria-label="Remove Image"
                onClick={() => handleRemoveImage(image)}
              >
                <img src={x} alt="remove-icon" />
              </div>
            )}
          </div>
        ))}
      </div>

      <div>
        <img
          className="rounded-lg object-cover my-3 md:w-full md:h-[750px]"
          src={selectedImage}
          alt="selected-image"
        />
      </div>
    </div>
  );
};
